// src/features/settings/settingsScopes.js

// Any write scope across any settings tab grants access — the old single
// `settings:closing-days` scope this checked was deleted entirely by the
// lukkedage/helligdage merge migration. Mirrors the Settings nav item's own
// gate in AppNavigation.jsx (canManageSettings) — keep both in sync. The user
// menu's Settings entry uses this list directly.
export const SETTINGS_WRITE_SCOPES = [
  'tidsregistering:non_working_day:create',
  'tidsregistering:non_working_day:update',
  'tidsregistering:non_working_day:delete',
  'tidsregistering:non_working_day:admin_generate',
  'inventory:product-group:create',
  'inventory:product-group:update',
  'inventory:product-group:delete',
  'inventory:stock:manage',
  'tidsregistering:registration_code:create',
  'tidsregistering:registration_code:update',
  'tidsregistering:registration_code:delete',
  'tidsregistering:overenskomst:create',
  'tidsregistering:overenskomst:update',
  'tidsregistering:overenskomst:delete',
  'inventory:scanner:create',
  'inventory:scanner:update',
  'inventory:scanner:delete',
  'infoscreen:create',
  'infoscreen:update',
  'infoscreen:delete',
];
